span.fp-text.-color-shade-900.-text-semi-bold
  | {{ pricing.totalCost.text }}
  span.fp-text.-text-regular(v-if='!hideCoinsPrice' data-test='coin-amount')
    | &nbsp;/&nbsp;{{ pricing.coins.text }}
